import { render, staticRenderFns } from "./BeeSilver.vue?vue&type=template&id=adc24d92&scoped=true&"
import script from "./BeeSilver.vue?vue&type=script&lang=js&"
export * from "./BeeSilver.vue?vue&type=script&lang=js&"
import style0 from "./BeeSilver.vue?vue&type=style&index=0&id=adc24d92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc24d92",
  null
  
)

export default component.exports